export const GoogleMapApiConfig = 'AIzaSyAIp2lZhtu9EXU6ciXPXHTTiMuQ260wAyA';